import React from "react";
import styled from "styled-components";
import { useOzonStoresStore } from "./use-ozon-stores-store";

const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const SearchInput = styled.input`
  padding: 7px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  width: 300px;
  &:focus {
    outline: none;
    border-color: #9b59b6;
  }
`;

const FilterSelect = styled.select`
  padding: 7px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
`;

export const OzonStoresFilters: React.FC = () => {
  const { query, syncStatus, limit, setQuery, setSyncStatus, setLimit } = useOzonStoresStore();

  return (
    <FiltersRow>
      <SearchInput
        placeholder="Поиск по клиенту, email или названию магазина..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <FilterSelect
        value={syncStatus}
        onChange={(e) => setSyncStatus(e.target.value)}
      >
        <option value="">Все</option>
        <option value="error">Ошибка загрузки</option>
      </FilterSelect>
      <FilterSelect
        value={limit}
        onChange={(e) => setLimit(Number(e.target.value))}
      >
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </FilterSelect>
    </FiltersRow>
  );
};
